import { FORM_ONBOARDING_REGISTER } from 'constants/forms'
import { mergeMap, take, switchMap } from 'rxjs/operators'
import { byType } from 'rxOperators/byType'
import { FORM_SUBMITTED_SUCCESSFULLY } from 'actions/formActions'
import { EMPTY, of } from 'rxjs'
import { isMemberPremiumSelector } from 'selectors/globalSelectors'
import { modifyFloatingPaneActionCreator, MODIFY_FLOATING_PANE } from 'actions/floatingPanesActions'
import { createAdvisorMeetingActionCreator, AdvisorMeetingActions } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { EpicRefined } from 'interfaces/middleware'
import FormActions from 'actions/formActions'
import FloatingPaneAction from 'actions/floatingPanesActions'

export const signupEpic: EpicRefined<FormActions | FloatingPaneAction | AdvisorMeetingActions> = (action$, store) => action$.pipe(
  byType(MODIFY_FLOATING_PANE),
  mergeMap(({ payload }) => {
    if (payload.type !== 'advisor' || payload.mode !== 'request' || payload.step !== 'signup') {
      return EMPTY
    }
    return of(payload.fields)
  }),
  switchMap((fields) => action$.pipe(
    byType(FORM_SUBMITTED_SUCCESSFULLY),
    mergeMap(({ payload }) => {
      if (payload.formName !== FORM_ONBOARDING_REGISTER || payload.formValues.form_mode !== 'meeting-panel') {
        return EMPTY
      }
      return of(payload)
    }),
    take(1),
    mergeMap(() => {
      const state = store.getState()
      const isMemberPremium = isMemberPremiumSelector(state)

      if (!isMemberPremium) {
        return of(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'subscription', fields }))
      }

      return of(
        createAdvisorMeetingActionCreator.request(fields),
        modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'booking' }),
      )
    })
  )),
)
